import { useEffect } from "react";
import { Container, ContentContainer } from "./TeamPageStyle";
import { useRecoilValue } from "recoil";
import { accessTokenAtom } from "../../recoil";
import { axios } from "../../apis/utils";
import { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Footer from "../../components/Footer/Footer";
import PageHeader from "../../components/TopHeader/PageHeader";
import Seo from "../../components/Seo";
import requiredAuth from "../../components/requiredAuth";
import { Button } from "@mui/material";

const TeamPage = () => {
  const accessToken = useRecoilValue(accessTokenAtom);
  const [team, setTeam] = useState([]);

  /* 체크 박스 */
  /* const [checkItems, setCheckItems] = useState([]);

  const handleSingleCheck = (checked, id) => {
    if (checked) {
      setCheckItems((prev) => [...prev, id]);
    } else {
      setCheckItems(checkItems.filter((el) => el !== id));
    }
  };

  const handleAllCheck = (checked) => {
    if (checked) {
      const idArray = [];
      team.forEach((el) => idArray.push(el.id));
      setCheckItems(idArray);
    } else {
      setCheckItems([]);
    }
  }; */

  const rename = async (id) => {
    const teamName = window.prompt("Please enter name to change");
    if (teamName) {
      try {
        await axios.post(
          "/teamRename",
          {
            id: id,
            teamName: teamName,
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        setTeam((prevTeams) =>
          prevTeams.map((team) =>
            team.id === id ? { ...team, teamName: teamName } : team
          )
        );
      } catch (error) {
        console.error("Error renaming team", error);
      }
    }
  };

  const addTeam = async () => {
    const teamName = window.prompt("Please enter the name of the team");
    if (teamName) {
      try {
        await axios.post(
          "/teamAdd",
          {
            teamName: teamName,
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        window.location.reload();
      } catch (error) {
        console.error("Error renaming team", error);
      }
    }
  };

  const deleteTeam = async (id) => {
    const check = window.confirm("Are you sure you want to delete Team?");
    if (check) {
      if (id) {
        try {
          await axios.post(
            "/teamDelete",
            {
              id: id,
            },
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          );
          window.location.reload();
        } catch (error) {
          console.error("Error delete team", error);
        }
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`/team`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        setTeam(res.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const openPopup = (id) => {
    const url = `/teamMember?id=${id}`;
    const width = 800;
    const height = 600;

    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
    const features = `width=${width},height=${height},left=${left},top=${top}`;
    window.open(url, "_blank", features);
  };

  return (
    <Container>
      <Seo title="팀관리" />
      <PageHeader title="팀관리" />
      <h1
        style={{
          borderBottom: "1px solid #000",
          margin: "20px 50px",
          paddingBottom: "20px",
          fontSize: "18px",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <span>Team List</span>
        <Button variant="outlined" type="button" onClick={() => addTeam()}>
          Add
        </Button>
      </h1>
      <ContentContainer>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                {/* <TableCell>
                  <input
                    type="checkbox"
                    onChange={(e) => handleAllCheck(e.target.checked)}
                  />
                </TableCell> */}
                <TableCell>No. </TableCell>
                <TableCell>teamName</TableCell>
                <TableCell align="center">createdAt</TableCell>
                <TableCell align="center">updatedAt</TableCell>
                <TableCell align="center">option</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {team.map((row, index) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  {/* <TableCell padding="checkbox">
                      <input
                        type="checkbox"
                        onChange={(e) =>
                          handleSingleCheck(e.target.checked, row.id)
                        }
                        checked={checkItems.includes(row.id) ? true : false}
                      />
                    </TableCell> */}
                  <TableCell component="th" scope="row">
                    {team.length - index}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.teamName}
                  </TableCell>
                  <TableCell align="center">{row.createdAt}</TableCell>
                  <TableCell align="center">{row.updatedAt}</TableCell>
                  <TableCell align="center">
                    <div>
                      <Button
                        variant="outlined"
                        type="button"
                        onClick={() => rename(row.id)}
                        sx={{
                          marginRight: "5px",
                        }}
                      >
                        Rename
                      </Button>
                      <Button
                        variant="outlined"
                        type="button"
                        onClick={() => deleteTeam(row.id)}
                        sx={{
                          marginRight: "5px",
                        }}
                      >
                        Delete
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => openPopup(row.id)}
                        type="button"
                      >
                        Member
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </ContentContainer>
      <Footer />
    </Container>
  );
};

export default requiredAuth(TeamPage);
